// @flow
import type {Node} from 'react'
import React, {Component, Fragment} from 'react'

import type {AsyncActionFunction} from 'components/types'
import Modal from 'components/ui/Modal'
import SaveButton from 'components/ui/SaveButton'
import DeleteButton from './DeleteButton'

type Props = {
  delete: ?AsyncActionFunction,
  disableSave: boolean,
  extraButton: ?(Node) => Node,
  leftBlock: ?() => Node,
  onSubmit: Object => void,
  save: ?AsyncActionFunction,
  saveTitle: string,
}

type State = {
  buttonsDisabled: boolean,
}

class Footer extends Component<Props, State> {
  state: State = {
    buttonsDisabled: false,
  }

  get saveDisabled(): boolean {
    return this.props.disableSave || this.state.buttonsDisabled
  }

  save: (() => void) = () => {
    if (this.props.save)
      this.submitModal(this.props.save)
  }

  delete: (() => void) = () => {
    if (this.props.delete)
      this.submitModal(this.props.delete)
  }

  submitModal: ((submit: AsyncActionFunction) => void) = (submit: AsyncActionFunction) => {
    this.disableButtons(() => {
      submit().then(this.props.onSubmit, this.enableButtons)
    })
  }

  disableButtons: ((callback: () => void) => void)
    = (callback: () => void) => this.setState({buttonsDisabled: true}, callback)

  enableButtons: (() => void) = () => this.setState({buttonsDisabled: false})

  saveButton: (() => null | Node) = () => (
    this.props.save
      ? (
        <SaveButton
          onClick={this.save}
          disabled={this.saveDisabled}
        >
          {this.props.saveTitle}
        </SaveButton>
      )
      : null
  )

  extraButton: (() => null | Node) = () => {
    const extraButton = this.props.extraButton

    return extraButton
      ? extraButton(this.saveButton())
      : this.saveButton()
  }

  renderLeftBlock: (() => null | Node) = () => {
    if (!this.props.leftBlock)
      return null

    return this.props.leftBlock()
  }

  render(): Node {
    return (
      <Modal.Footer
        leftBlock={this.renderLeftBlock()}
        rightBlock={(
          <Fragment>
            {this.extraButton()}
            {this.props.delete && (
              <DeleteButton
                disabled={this.state.buttonsDisabled}
                onClick={this.delete}
              />
            )}
          </Fragment>
        )}
      />
    )
  }
}

export default Footer
